module.exports = __webpack_public_path__ + "static/img/defaultHead.6c12504.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultHead.png
// module id = 7ADV
// module chunks = 1